import { Component, OnInit } from '@angular/core';
import * as fromProcess from '../../store/process/process.reducer';
import { BehaviorSubject, first, map, Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '../../store';
import { environment } from '../../environments/environment';
import { ProcessService } from '../../services/process.service';

@Component({
  selector: 'app-agent-success',
  templateUrl: './agent-success.component.html',
  styleUrls: ['./agent-success.component.scss'],
})
export class AgentSuccessComponent implements OnInit {
  processKind$ = this.store.select(fromProcess.selectProcessKind);
  conclusionData$ = this.store.select(fromProcess.selectProcessConclusionData);
  summaryParams$ = new BehaviorSubject<{
    policyNumber: string;
  }>({ policyNumber: '—' });

  constructor(private store: Store<AppState>, private processService: ProcessService) {}

  get policyPdf$(): Observable<string | undefined> {
    return this.conclusionData$.pipe(
      map((conclusionData) =>
        conclusionData ? `${environment.baseApiUrl}globapi/pub/policy/pdf?hashCode=${conclusionData.result.hashCode}` : undefined,
      ),
      first(),
    );
  }

  ngOnInit() {
    this.store.dispatch(fromProcess.actions.setStep({ step: 9 }));
    this.processService.onPageInit();

    this.conclusionData$.subscribe((conclusionData) => {
      this.summaryParams$.next({
        policyNumber: conclusionData?.result.policyNumber || '—',
      });
    });
  }
}
